
export enum middleType {
    none = 'none',
    H = 'H',
    G = 'G',
}